import UmlShape from './UmlShape';

// Vertical dashed line under a participant, spanning the message area.
// TRACKS its participant's live x-position via participantId (looked up
// through getShapeById at render time, see UmlSeqLifelineWidget) instead of
// a fixed x — behaves like a connector that's always vertically under its
// class, following drags of the participant OR its parent package. Fixed
// x/y/w/h below is only the fallback used if the participant can't be found
// (e.g. it was deleted). Fixed y/height: does NOT track vertical drags of
// the participant (v1 scope, agreed 2026-07-19 — "always vertical under
// class" was specifically about horizontal drag).
class UmlSeqLifelineShape extends UmlShape {
  constructor(id, x, y, w, h, participantName, participantId) {
    super(id, x, y, w, h);
    this.participantName = participantName;
    this.participantId = participantId;
    this.kind = 'seq-lifeline'; // discriminant voor UmlShapeSerializer.fromPlainShape
  }
}

export default UmlSeqLifelineShape;
